import { Button, Typography, Space, Row, Col, Card } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { SmileOutlined } from '@ant-design/icons'
import AppContext from 'src/hooks/AppContext'
import { destroyCookie } from 'nookies'

const { Title, Text } = Typography

const Welcome = () => {
  const { userInfo } = useContext(AppContext)
  const navigate = useNavigate()

  const deleteToken = () => {
    sessionStorage.removeItem('token')
    destroyCookie({} as any, 'token', { path: '/', secure: true })
  }

  const handleLogout = () => {
    deleteToken()
    navigate('/login')
  }

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#000000',
      }}
    >
      <Card style={{ maxWidth: '600px', textAlign: 'center', padding: '40px' }}>
        <Space direction="vertical" size="large">
          <Row justify="center">
            <Col>
              <SmileOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
            </Col>
          </Row>
          <Title level={2}>Welcome {userInfo?.username || 'User'}!</Title>
          <Text type="secondary">
            We're excited to have you here. Explore and enjoy your experience
            with us.
          </Text>
        </Space>
      </Card>
    </div>
  )
}

export default Welcome
